<template>
    <div class="main">
        <el-row>
            <p>2D</p>
        </el-row>
        <el-row class="split-line">
            <el-col id="preview" class="de_view" :span="12">
                <DesignerView v-if="data" style="width:200px;height:300px;margin:auto" :data="data" :height="300"
                    :width="200"></DesignerView>
            </el-col>
            <div style="background:black;width:1px;height:100%;"></div>
            <el-col :span="12">
                <img :src="imgSrc" />
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="8" class="vert-split-line">
                <div class="chart-container" ref="score"></div>
            </el-col>
            <el-col :span="8" class="vert-split-line">
                <div class="chart-container">
                    <el-descriptions class="margin-top" :column="1" :size="size" border>
                        <el-descriptions-item :key="e" v-for="(i, e) in basic_info" :label="e">{{  i  }}{{  units[e]  }}
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="chart-container"></div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import DesignerView from './components/DesignerView.vue'
import axios from "axios";
import { baseUrl } from './config/baseUrl';
import { commit_rooms } from './api/options';
export default {
    name: "PreviewPage",
    components: { DesignerView },
    data: () => {
        return {
            rooms: [],
            width: "",
            height: "300px",
            imgSrc: "150px",
            data: null,
            basic_info: {},
            units: {
                '房间数量': '',
                '面宽': '米',
                '进深': '米',
                '套内面积': '平方米',
                '供暖-制冷负荷': 'kWh/年'
            }
        }
    },
    async created() {
        let data = await axios.post(`${baseUrl}/get?id=` + this.$route.params.id);
        this.data = data.data.data;
        this.drawChart();
    },
    methods: {
        drawChart() {
            this.basic_info = JSON.parse(this.data.basic_info);
            let tmp = JSON.parse(this.data.energy_load);
            this.basic_info['供暖-制冷负荷'] = tmp['供暖-制冷负荷'];
            let scores = JSON.parse(this.data.scores);
            let x = [], y = [];
            for (let i in scores) {
                x.push(i);
                y.push(scores[i])
            }
            let option = {
                xAxis: {
                    type: 'category',
                    data: x
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: y,
                        type: 'bar'
                    }
                ]
            };
            var charts = this.$echarts.init(this.$refs.score);
            charts.setOption(option);
        },
        shot() {
            this.$Screenshot(document.querySelector("#preview")).then(canvas => {
                let img = canvas.toDataURL("image/jpeg", 0.8);
                console.log("123123", img);
                this.imgSrc = img;
            });
        }
    }
}
</script>
<style scoped>
.main {
    width: 1024px;
    margin: auto;
}

.de_view {
    text-align: center !important;
    margin: auto;
    height: 100%;
}

.split-line {
    border-bottom: 1px solid black;
}

.vert-split-line {
    border-right: 1px solid black;
}

.chart-container {
    height: 300px;
    padding: 20px;
}
</style>